const { SHARED_EVENTS } = require("./sharedEvents");

function getInitialConfigObjectMessageBuilder({ placeholder, style }) {
  return (propName) => ({
    message: SHARED_EVENTS.initialConfig,
    placeholder: placeholder?.[propName],
    style,
  });
}

module.exports = {
  getInitialConfigObjectMessageBuilder,
};
